import { useEffect, useState } from 'react';
import styles from './AuthenticationPage.module.scss'; // Import des styles SCSS modulaires
import { useNavigate, useParams } from 'react-router-dom';
import UserService from '../../services/UserService';
import { catchError, storeToken } from '../../services/DaoService';
import { useUserContext } from '../../contexts/UserContext';

const AuthenticationPage = () => {
    const [loading, setLoading] = useState(true); // Gérer l'état de chargement
    const { token } = useParams(); // Récupérer le token de l'URL
    const {setCurrentUser} = useUserContext();
    const navigate = useNavigate(); // Utilisation de la fonction de navigation

    // Effect pour appeler la fonction d'authentification lors du montage du composant
    useEffect(() => {
        if (!token) {
            navigate('/login');
        }
        UserService.getInstance().verifyToken({
            token
        })
        .then((response) => {
            storeToken(response.data.token);
            setCurrentUser(response.data.user);
            window.location.href = '/';
        })
        .catch((error) => {
            catchError(error);
            navigate('/login');
        }).finally(() => {
            setLoading(false);
        });
    }, [token, setCurrentUser, navigate]); // Déclenche uniquement lorsque l'URL change
    
    if (loading) {
        return (
            <div className={styles.loaderContainer}>
                <div className={styles.loader}></div>
            </div>
        );
    }
    
    return null; // Vous pouvez également rediriger si nécessaire après la vérification
};

export default AuthenticationPage;
